export const LOTTERY_TICKET_PRICE_CASH = 5000;

